(function () {
    window.addEventListener('load', function (e) {
        renderHistory();
    });
    async function renderHistory() {
        const history = Cookies.getJSON('product_history');
        if (history == undefined || history.length == 0) {
            return;
        }

        const target = document.getElementById('product_history');
        if (target == null) {
            return;
        }
        let size = 4;
        if (target.dataset.size != undefined) {
            size = Number(target.dataset.size);
        } 
        const layout = document.getElementById('ph-layout-template').cloneNode(true);
        const ul = layout.querySelector('#ph-list');

        for (const handle of history.slice(0,size)) {
            const product = await getProductInfo(handle);
            const item = makeItem(product);
            ul.append(item);
        }

        layout.style.display = 'block';
        target.append(layout);
    }
    async function getProductInfo(handle) {
        const response = await fetch('/products/'+handle+'.js');
        const data = await response.json();
        return data;
    }

    function makeItem(product) {
        const template = document.getElementById('ph-item-template').cloneNode(true);
        template.querySelectorAll('.ph-item-title').forEach(elm => {elm.append(document.createTextNode(product.title))}); 
        template.querySelector('#ph-item-image').src = product.featured_image;
        template.querySelector('#ph-item-anchor').href = product.url;
        // month tag
        const monthTag = makeMonthTag(product.tags);
        if (monthTag !== '') {
            const month = template.querySelector('#ph-item-month');
            month.outerHTML = monthTag;
        }

        // prict
        let priceRegular = '';
        if (product.price_varies) {
            priceRegular = '¥' + (product.price_min/100).toLocaleString() + ' 〜 ¥' + (product.price_max/100).toLocaleString();
        } else {
            priceRegular = '¥' + (product.price/100).toLocaleString();
        }
        template.querySelector('#ph-item-price-regular').append(document.createTextNode(priceRegular));
        let priceSale = '';
        if (product.price_varies) {
            priceSale = '¥' + (product.price/100).toLocaleString() + 'から';
        } else {
            priceSale = '¥' + (product.price/100).toLocaleString();
        }
        template.querySelector('#ph-item-price-sale').append(document.createTextNode(priceSale));
        if (product.compare_at_price > product.price) {
            template.querySelector('#ph-item-price').classList.add('price--on-sale');
        }
        if (product.compare_at_price != null) {
            const priceCompare = '¥' + (product.compare_at_price/100).toLocaleString();
            template.querySelector('#ph-item-price-compare').append(document.createTextNode(priceCompare));    
        }


        // soldout 
        if (!product.available) {
            template.querySelector('#ph-item-wrapper').classList.add('grid-view-item--sold-out');
            template.querySelector('#ph-item-soldout').style.display = 'flex';
            template.querySelector('#ph-item-price').classList.add('price--sold-out');
        }
        template.style.display = 'block';
        return template;
    }

    function makeMonthTag(tags) {
        let monthTags = tags.filter(tag => {
            return tag.startsWith('_販売月_') && tag != '_販売月_通年';
        });
        monthTags = monthTags.map(tag => tag.replace('_販売月_', ''));
        let reverse = false;
        if (monthTags.includes('1月')) {
            for (const m of ['10月', '11月', '12月']) {
                if (monthTags.indexOf(m)) reverse = true;
            };
        }
        let months = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
        if (reverse) {
            months = ['10月', '11月', '12月', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月'];
        }

        let tagStr = '';
        for (const m of months) {
            if (monthTags.includes(m)) {
                tagStr = tagStr + "<div>" + m + "</div>\n";
            }
        }
        return '<div class="month">' + tagStr + '</div>';
    }
})();
